import { ErrorMessage } from "formik"
import { ItemsWrapperProps } from "../types"
import FieldItem from "./FieldItem"

const ItemsWrapper = ({ title, items }: ItemsWrapperProps) => {
  return (
    <div className='login-form__wrapper'>
      <h3 className='card-list-heading spacer-v2'>{title}</h3>
      {items.map((item, index) => (
        <div className={item.isFullWidth ? "login-form__row-full" : "login-form__row"} key={`login-form__row-${index}`}>
          {item.fields.map((field, index) => (
            <div className='login-form__input' key={`login-form__input-${index}`}>
              <div className='login-form__input-inner-box'>
                {field.type === "text" && (
                  <label className='login-form__label' htmlFor={field.name}>
                    {field.label}
                    {field.required && <span className='login-form__label-required'> *</span>}
                  </label>
                )}
                <FieldItem {...field} />
              </div>
              {field.type == "text" && (
                <ErrorMessage name={field.name} component='span' className='login-form__error-message' />
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}

export default ItemsWrapper
